export class FolderHistory {
  folderId: string;
  createDateTime: Date;
  updateDateTime: Date;
  comment: string;
  password: string;
  published: boolean;
  isDeleted: boolean;
}
